<div class="timepicker" [attr.show]="show">
  <div class="time-header">Time</div>
  <mat-form-field class="time-field">
    <mat-label>Hour</mat-label>
    <mat-select [(ngModel)]="hour">
      @for (h of hours; track h) {
        <mat-option [value]="h">{{ h }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="time-field">
    <mat-label>Minute</mat-label>
    <mat-select [(ngModel)]="minute">
      @for (minOpt of minutes; track minOpt) {
        <mat-option [value]="minOpt">{{ minOpt }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
  <mat-form-field class="time-field">
    <mat-select [(ngModel)]="ampm">
      <mat-option value="AM">AM</mat-option>
      <mat-option value="PM">PM</mat-option>
    </mat-select>
  </mat-form-field>
  <div class="time-footer">
    <div class="time-buttons">
      <button type="button" class="btn" (click)="cancelClick()">Cancel</button>
      <button type="button" class="btn btn-primary" [disabled]="!canConfirmSelection()" [attr.aria-disabled]="!canConfirmSelection()" (click)="updateClick()">Done</button>
    </div>
  </div>
</div>